import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { updatePassword, reset } from "../../../redux/auth/authSlice";
import { useSearchParams, useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader";
import { toast } from "react-toastify";
import Layout from "../../../components/layout/Layout";
import { Button } from "react-bootstrap";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { blobURL } from "common/StringUtils";
import { Helmet } from "react-helmet";
import { LOCALES } from "common/constants";

const SetNewPassword = () => {
  const signupCover = `${blobURL}/createPasswordImg.webp`;

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [token, setToken] = useState();
  const [passVisible, setPassVisibile] = useState(false);
  let language = localStorage.getItem("i18nextLng");

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger
  } = useForm();
  const dispatch = useDispatch();
  const { isLoading, isSuccess, isError, message } = useSelector(
    (state) => state.auth
  );
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    return () => dispatch(reset());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      toast.error(message);
      dispatch(reset());
    }
  }, [isError, message, dispatch]);

  useEffect(() => {
    if (isSuccess) {
      toast.success(t("Your password has been updated."));
      dispatch(reset());
      navigate(
        language === LOCALES.EN_US ? `/emaillogin?lang=${LOCALES.EN_US}` : `/e-postinloggning?lang=${LOCALES.SV_SE}`
      );
    }
  }, [isSuccess, dispatch, language, navigate, t]);

  useEffect(() => {
    if (searchParams.get("token")) {
      setToken(searchParams.get("token"));
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("token");
      setSearchParams(newParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);
  

  useEffect(() => {
    trigger();
  }, [language]); 

  const onSubmit = (values) => {
    if (token) {
      dispatch(updatePassword({ password: values.password, token }));
    }
  };

  return (
    <Layout className="d-flex forgot" hidefooter headerColor="secondary">
      <Helmet>
        <link
          rel="canonical"
          href="https://invozio.com/set-nytt-losenord"
        />
      </Helmet>
      {isLoading && <Loader />}
      <div className="w-50 d-flex hide-mobile">
        <img
          src={signupCover}
          alt="login cover"
          className="m-auto w-90 imageShadows"
          loading="lazy"
        />
      </div>
      <div className="w-50 d-flex">
        <form
          className="w-75 px-5 m-auto text-center passcreate"
          onSubmit={handleSubmit(onSubmit)}
        >
          <h1 className="mb-5 mt-5 text-dark">{t("Create new password")}</h1>
          <div className="input-group">
            <input
              type={passVisible ? "text" : "password"}
              className="form-control mt-0 secondary"
              placeholder={t("New Password")}
              required
              {...register("password", {
                minLength: {
                  value: 8,
                  message: t("Password must be atleast 8 characters in length"),
                },
                pattern: {
                  value:
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/i,
                  message: t(
                    "Password must have a capital letter and a number, and hyphen is also not accepted in the password"
                  ),
                },
              })}
            />
            <div className="input-group-append pr-3">
              {passVisible ? (
                <AiOutlineEyeInvisible
                  className="m-auto"
                  size={24}
                  onClick={() => setPassVisibile(false)}
                />
              ) : (
                <AiOutlineEye
                  className="m-auto"
                  size={24}
                  onClick={() => setPassVisibile(true)}
                />
              )}
            </div>
          </div>
          <div className="input-group mt-3">
            <input
              type={passVisible ? "text" : "password"}
              className="form-control mt-0 secondary"
              placeholder={t("Confirm New Password")}
              required
              {...register("confirmPassword", {
                minLength: {
                  value: 8,
                  message: t("Password must be atleast 8 characters in length"),
                },
                pattern: {
                  value:
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/i,
                  message: t(
                    "Password must have a capital letter and a number, and hyphen is also not accepted in the password"
                  ),
                },
                validate: (value) =>
                  value === watch("password") || t("The passwords do not match"),
              })}
            />
            <div className="input-group-append pr-3">
              {passVisible ? (
                <AiOutlineEyeInvisible
                  className="m-auto"
                  size={24}
                  onClick={() => setPassVisibile(false)}
                />
              ) : (
                <AiOutlineEye
                  className="m-auto"
                  size={24}
                  onClick={() => setPassVisibile(true)}
                />
              )}
            </div>
          </div>
          {Object.keys(errors).length > 0 && (
            <div className="text-center w-100 mt-3">
              <p className="text-danger">
                {errors[Object.keys(errors)[0]]?.message}
              </p>
            </div>
          )}
          <Button
            type="submit"
            className="mt-4 ml-3 text-light new_theme_btn border-0"
          >
            {t("Reset Password")}
          </Button>
        </form>
      </div>
    </Layout>
  );
};

export default SetNewPassword;
